import { generatePath, Link } from 'react-router-dom';
import { Typography } from 'antd';
import { routePaths } from 'router/route-paths';
import { CargoItemStatuses } from 'components/cargos/cargo-item-status';
import type { IWhInfoCargoCardProps } from './types';
import styles from './wh-info-cargo-card.module.scss';

export const WhInfoCargoCard: React.FC<IWhInfoCargoCardProps> = ({ cargo }) => {
  return (
    <div className={styles.cargoCard}>
      <div className={styles.cargoHeader}>
        <h3 className={styles.compositeId}>
          <Link to={generatePath(routePaths.cargo, { cargoId: String(cargo.id) })}>{cargo.compositeId}</Link>
        </h3>
      </div>

      <div>
        <CargoItemStatuses statuses={cargo.statuses} assetIsReturned={cargo.assetIsReturned} />
      </div>
      <div>
        <Typography.Text>
          LDM: {cargo.totalLDM || 0} / Weight: {cargo.totalWeight || 0} / Volume: {cargo.totalVolume || 0}
        </Typography.Text>
      </div>
    </div>
  );
};
